<div id="footerfilter">
<app-breadcrumb></app-breadcrumb>
</div>

<!-- <div *ngIf="successMessage!=null" class="alert alert-success alert-dismissible fade show" role="alert">
    <button type="button" class="btn-close" (click)="close()" data-bs-dismiss="alert" aria-label="close"></button>
    <strong>{{successMessage}}</strong>
</div>
<div *ngIf="errorMessage!=null" class="alert alert-danger alert-dismissible">
    <button type="button" class="btn-close" (click)="close()" data-bs-dismiss="alert" aria-label="close"></button>
    <strong>{{errorMessage}}</strong>
</div> -->
<app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
</app-notification-message>

<div id="headerfilter">
<div class="d-flex justify-content-between ms-4 me-3 roboto-medium">
    <h2 class="roboto-medium title">History</h2>
    <div>
        <button class='b2 mb-2' (click)="openDeletions()">VIEW EVENT DELETIONS</button>
        <button (click)="openLegends()" class='b2 mb-2'>LEGENDS</button>
        <button class='b2 mb-2' (click)='save()' type="submit" value="save">SAVE PREFERENCE</button>
        <button class='b2 mb-2' (click)='reset()' type="submit" value="reset">RESET DEFAULT PREFERENCE</button>
        <button (click)="openColumns()" class='b2 mb-2'>COLUMN OPTIONS</button>
    </div>
</div>
</div>


<h4 class="roboto ms-4">AET Events/Resolutions</h4>
<div class="grid-agg px-4" id="LIOS-grid">
    <ag-grid-angular class="ag-theme-balham grid-items history-grid" (gridReady)="onGridReady($event);" (window:resize)="sizeToFit()"
        [rowHeight]="rowHeight" [animateRows]="true" [defaultColDef]="defaultColDef" [columnDefs]="columnDefs"
        [suppressCellFocus]="true" [pagination]="true" [paginationPageSize]="paginationPageSize"
        [suppressPaginationPanel]="true" [headerHeight]="40" [floatingFiltersHeight]="40" [icons]="icons"
        (paginationChanged)="onPaginationChanged()" [rowClassRules]="rowClassRules" (filterChanged)="onFilterChanged($event)"
        [context]="gridContext"
        [theme]="'legacy'" >
    </ag-grid-angular>

    <div class="d-flex pagination px-2 align-items-center justify-content-between">
        <div>
            <div>
                <label class="page-drpdwn-label me-2">Records/Page: </label>
                <select (change)="onPageSizeChanged($event)" class="paginate_drpdwn">
                    <option value="5">5</option>
                    <option value="10" selected>10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value={{rowCount}}>ALL</option>
                </select>
            </div>
        </div>
        <div class="d-flex align-items-center gap-3">
            <div>Viewing Records</div>

            <!-- <mat-icon (click)="goToFirstPage()" class="text-primary"
                [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">fast_rewind
            </mat-icon>
            <mat-icon (click)="goToPreviousPage()" class="text-primary"
                [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">
                skip_previous</mat-icon> -->



            <img src="assets/images/Icon awesome-fast-forward.svg" width="10" (click)="goToFirstPage()"
                class="text-primary reverse firstPage"
                [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">

            <img src="assets/images/Icon metro-next.svg" (click)="goToPreviousPage()" class="text-primary reverse previousPage"
                [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">

            <div>
                (
                <span class="value" id="lbCurrentPage"></span> -
                <span class="value" id="lbTotalPages"></span>)&nbsp; OF &nbsp;
                <span>{{rowCount}}</span>
            </div>

            <!-- <mat-icon (click)="goToNexpage()" class="text-primary"
                [ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}">
                skip_next</mat-icon>
            <mat-icon (click)="goToLastPage()" class="text-primary"
                [ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}">
                fast_forward</mat-icon> -->

            <img src="assets/images/Icon metro-next.svg" (click)="goToNexpage()" class="text-primary nextPage"
                [ngClass]="{'disable_icon':(isLastPage()== true || rowCount==0),'enable_icon':(isLastPage()!= true || rowCount>0)}">
            <img src="assets/images/Icon awesome-fast-forward.svg" width="10" (click)="goToLastPage()"
                class="text-primary lastPage" [ngClass]="{'disable_icon':(isLastPage()== true || rowCount==0),'enable_icon':(isLastPage()!= true || rowCount>0)}">
        </div>
    </div>
</div>